import { Currency } from '@/core/currency/interfaces';

const ZWL: Currency = {
    name: 'Zimbabwean Dollar',
    demonym: 'Zimbabwean',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '932',
    symbol: 'Z$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'ZWL',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default ZWL;
